import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ActionsPopover from '../popovers/ActionsPopover'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useCallback } from 'react';
import { useMemo } from 'react';
import { TableRow, TableCell, Chip, Box } from '@mui/material';

const UserRow = ({user, onAction, refresh, userReducer, history}) => {
  const groups = user.groupOptions || [];
  const isAdmin = userReducer?.userType?.toLowerCase() === 'admin';
  const currentUserId = userReducer?.userId;
  const userId = user._id || user.id;
  const isCurrentUser = currentUserId && userId && currentUserId.toString() === userId.toString();
  const canEdit = isAdmin || isCurrentUser;

  const handleEditClick = useCallback(() => {
    if (onAction) {
      onAction('edit', user);
    }
  }, [onAction, user]);

  const handleDeleteClick = useCallback(() => {
    if (onAction) {
      onAction('delete', user);
    }
  }, [onAction, user]);

  const userActions = useMemo(() => {
    if (!isAdmin) return [];
    return [
      { key: 'edit',       label: 'Edit' },
      { key: 'deactivate', label: (user.isActive ? 'Deactivate' : 'Activate') },
      { key: 'delete',     label: 'Delete', danger: true }
    ];
  }, [isAdmin, user.isActive]);

  const renderGroups = useCallback(() => {
    if (!groups.length) {
      return (
        <Chip
          label="No Groups"
          size="small"
          variant="outlined"
          sx={{ opacity: 0.6 }}
        />
      );
    }

    return groups.map((group) => (
      <Chip
        key={group.id}
        label={group.name}
        size="small"
        variant="outlined"
        {...(isAdmin ? {
          clickable: true,
          color: "primary",
          onClick: (e) => {
            e.stopPropagation();
            history.push(`/site/administration/UserGroupDetails/${group.id}`);
          }
        } : {})}
      />
    ));
  }, [groups, history, isAdmin]);


    return (
      <TableRow
        hover
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
          opacity: user.isActive ? 1 : 0.6
        }}
      >
        <TableCell align="center" sx={{ width: 50 }}>
          {isAdmin && (
            <ActionsPopover
              entity={user}
              items={userActions}
              onAction={onAction}
              refresh={refresh}
            />
          )}
        </TableCell>
        <TableCell align="center" sx={{ width: 50 }}>
          {canEdit && (
            <div
              className='s-icon-circle'
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick();
              }}
            >
              <DriveFileRenameOutlineIcon
                id="editIcon"
                className='edit-icon-pencil'
              />
            </div>
          )}
        </TableCell>
        <TableCell align="center" sx={{ width: 50 }}>
          {isAdmin && (
            <div
              className='s-icon-circle'
              onClick={(e) =>{
                e.stopPropagation();
                handleDeleteClick();
              }}
            >
              <DeleteOutlineOutlinedIcon
                id="deleteIcon"
                className='delete-icon-bin'
              />
            </div>
          )}
        </TableCell>
        <TableCell>{user.username}</TableCell>
        <TableCell>{user.name}</TableCell>
        <TableCell>{user.email}</TableCell>
        <TableCell>
          <Chip
            label={user.isActive ? "Active" : "Inactive"}
            size="small"
            color={user.isActive ? "success" : "default"}
            variant="outlined"
          />
        </TableCell>
        <TableCell>
          <Chip
            label={user.type?.charAt(0).toUpperCase() + user.type?.slice(1)}
            size="small"
            color={
              user.type?.toLowerCase() === 'admin' ? 'error' :
              user.type?.toLowerCase() === 'edm' ? 'warning' :
              'default'
            }
          />
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
            {renderGroups()}
          </Box>
        </TableCell>
      </TableRow>
    );
};

export default withRouter(connect((state) => state)(UserRow));
